import { Flex } from '@mantine/core'

import { AddAccount } from '@/components/AddAccount/AddAccount'
import { Text } from '@/components/Text/Text'

export function ValueChartNoAccountsNotice({
  isUser = false,
}: {
  isUser?: boolean
}) {
  return (
    <Flex
      align="center"
      direction="column"
      h={183}
      justify="center"
      mb={36}
      mt={25}
      w="100%"
    >
      <Text mb={16} variant="body_2_black">
        No accounts added
      </Text>

      {isUser && (
        <Text mt={-16} variant="body_2_black">
          Contact the employee to add an account
        </Text>
      )}

      {!isUser && <AddAccount />}
    </Flex>
  )
}
